import React from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CheckboxWithLabelProps {
  id: string;
  name: string;
  register: UseFormRegister<any>;
  errors?: FieldErrors<any>;
  labelContent: React.ReactNode;
}

const CheckboxWithLabel: React.FC<CheckboxWithLabelProps> = ({
  id,
  name,
  register,
  errors,
  labelContent,
}) => {
  const { t } = useTranslation();
  const error = errors?.[name];
  const errorMessage =
    typeof error?.message === "string" ? error.message : undefined;

  return (
    <div className="form-item">
      <div className="d-flex flex-wrap align-items-start">
        <input
          type="checkbox"
          id={id}
          {...register(name)}
          aria-invalid={!!errorMessage}
          aria-describedby={errorMessage ? `${id}-error` : undefined}
        />
        <label className="inputArea-label" htmlFor={id}></label>
        <label
          className={`form-input-label ${
            navigator.language.includes("ko") ? "" : "mg ml-24"
          }`}
        >
          {labelContent}
        </label>
      </div>

      {errorMessage && (
        <div id={`${id}-error`} className="text-danger mt-2" role="alert">
          {t(errorMessage)}
        </div>
      )}
      <div className="mg mt-20 form-item-delete">{t("siteType.info")}</div>
    </div>
  );
};

export default CheckboxWithLabel;
